import { render, staticRenderFns } from "./FeeForm.vue?vue&type=template&id=1a21f324&"
import script from "./FeeForm.vue?vue&type=script&lang=js&"
export * from "./FeeForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports